import parser from 'ua-parser-js';
import { detect } from 'detect-browser';

export const Device = {
  IS_MOBILE: true,
  IS_TABLET: true,
  IS_DESKTOP: true,
};

export const Browser = {
  IS_MOBILE_SAFARI: false,
  NAME: 'unknown',
};

export const detectDevice = str => {
  const parsed = parser(
    str || (
      (typeof window === 'object' && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : ''),
  );
  if (parsed) {
    Device.IS_MOBILE = ['mobile'].includes(parsed.device.type);
    Device.IS_TABLET = ['tablet'].includes(parsed.device.type);
    Device.IS_DESKTOP = !['tablet', 'mobile'].includes(parsed.device.type);
    Browser.IS_MOBILE_SAFARI = ['Mobile Safari'].includes(parsed.browser.name);
  }
  if (typeof window === 'object' && window.navigator && window.navigator.userAgent) {
    const browser = detect();
    Browser.NAME = browser.name;
  }
};
